import { render, staticRenderFns } from "./DialogRescheduleAppointment.vue?vue&type=template&id=40080dd8&scoped=true&"
import script from "./DialogRescheduleAppointment.vue?vue&type=script&lang=ts&"
export * from "./DialogRescheduleAppointment.vue?vue&type=script&lang=ts&"
import style0 from "./DialogRescheduleAppointment.vue?vue&type=style&index=0&id=40080dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40080dd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VDatePicker,VRadio,VRadioGroup,VWindow,VWindowItem})
